import React from "react";
import { Routes, Route } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import Login from "./pages/Login/Login";
import AgentView from "./pages/AgentView/AgentView";
import MainView from "./pages/AdminView/MainView/MainView";

import "./App.scss";
import { ConfigProvider, theme } from "antd";
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // useErrorBoundary: true,
      refetchOnWindowFocus: false,
    },
  },
});
function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ConfigProvider
        theme={{
          algorithm: theme.defaultAlgorithm,
        }}
      >
        <div className="App">
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="agentView/*" element={<AgentView />} />
            <Route path="mainView/*" element={<MainView />} />
          </Routes>
        </div>
      </ConfigProvider>
    </QueryClientProvider>
  );
}

export default App;
